import { SVGAttributes } from "react";

const VerifiedCheck: React.FC<SVGAttributes<SVGElement>> = ({ ...props }) => (
  <svg
    viewBox="0 0 12 12"
    preserveAspectRatio="xMinYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2043_82439)">
      <path d="M12 0.25H0.5V11.75H12V0.25Z" fill="#B7FF2C" />
      <path
        d="M6.22337 8.14191C4.99949 8.66214 3.07899 9.2578 2.27846 7.96786C1.83202 7.2523 2.1149 6.13642 2.77302 5.11917C3.19253 4.46936 3.73134 3.87178 4.27016 3.27612C3.97189 3.76348 3.1271 5.39185 4.23167 6.20798C4.6608 6.51934 5.41707 6.55222 6.35807 6.30661L17.5828 3.32641L6.22144 8.14385L6.22337 8.14191Z"
        fill="black"
      />
    </g>
    <rect x="1" y="0.75" width="10.5" height="10.5" stroke="#B7FF2C" />
    <defs>
      <clipPath id="clip0_2043_82439">
        <rect x="0.5" y="0.25" width="11.5" height="11.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default VerifiedCheck;
